import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useAuthenticationStore } from "@/stores/authentication";
import { UserPermissionsService } from "@/services/userPermissions";

/**
 * Composable for the signed-in user and their platform-level permissions
 */
export function useMe() {
    const authStore = useAuthenticationStore();
    const { user } = storeToRefs(authStore);

    const isPlatformAdmin = computed((): boolean =>
        user.value ? UserPermissionsService.isPlatformAdmin(user.value) : false,
    );

    const hasPortalAccess = computed((): boolean =>
        user.value ? UserPermissionsService.hasPortalAccess(user.value) : false,
    );

    const canManageUsers = computed((): boolean =>
        user.value ? UserPermissionsService.canManageUsers(user.value) : false,
    );

    return {
        user,
        isPlatformAdmin,
        hasPortalAccess,
        canManageUsers,
        fetchCurrentUser: authStore.fetchCurrentUser,
        isAuthenticated: authStore.isAuthenticated,
    };
}
